"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Translates between an RDF literal and a JavaScript primitive.
 */

var Translator =
/*#__PURE__*/
function () {
  function Translator() {
    _classCallCheck(this, Translator);

    this.supportedRdfDatatypes = [];
    this.fromRdfHandlers = {};
    this.toRdfHandlers = {};
  }

  _createClass(Translator, [{
    key: "registerHandler",
    value: function registerHandler(handler, rdfDatatypes, javaScriptDataTypes) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = rdfDatatypes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var rdfDatatype = _step.value;
          this.supportedRdfDatatypes.push(rdfDatatype);
          this.fromRdfHandlers[rdfDatatype.value] = handler;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = javaScriptDataTypes[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var javaScriptDataType = _step2.value;
          var existingToRdfHandlers = this.toRdfHandlers[javaScriptDataType];

          if (!existingToRdfHandlers) {
            this.toRdfHandlers[javaScriptDataType] = existingToRdfHandlers = [];
          }

          existingToRdfHandlers.push(handler);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  }, {
    key: "fromRdf",
    value: function fromRdf(literal, validate) {
      var handler = this.fromRdfHandlers[literal.datatype.value];

      if (handler) {
        return handler.fromRdf(literal, validate);
      } else {
        return literal.value;
      }
    }
  }, {
    key: "toRdf",
    value: function toRdf(value, dataFactory) {
      var handlers = this.toRdfHandlers[typeof value];

      if (handlers) {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = handlers[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var handler = _step3.value;
            var ret = handler.toRdf(value, dataFactory);

            if (ret) {
              return ret;
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      }

      throw new Error("Invalid JavaScript value: '".concat(value, "'"));
    }
    /**
     * @return {NamedNode[]} An array of all supported RDF datatypes.
     */

  }, {
    key: "getSupportedRdfDatatypes",
    value: function getSupportedRdfDatatypes() {
      return this.supportedRdfDatatypes;
    }
    /**
     * @return {string[]} An array of all supported JavaScript types.
     */

  }, {
    key: "getSupportedJavaScriptPrimitives",
    value: function getSupportedJavaScriptPrimitives() {
      return Object.keys(this.toRdfHandlers);
    }
  }], [{
    key: "incorrectRdfDataType",
    value: function incorrectRdfDataType(literal) {
      throw new Error("Invalid RDF ".concat(literal.datatype.value, " value: '").concat(literal.value, "'"));
    }
  }]);

  return Translator;
}();

exports.Translator = Translator;